import React from "react";
import {
  MDBContainer,
  MDBInput,
  MDBCol,
  MDBRow,
  MDBSwitch,
  MDBBtn,
  MDBIcon,
} from "mdb-react-ui-kit";
import "./UserEditForm.css";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";
import eventBus from "Projects/CC_cubi_clan_project/Utils/EventBus";
import { validatePasswordStrength } from "Projects/SSO_single_sign_on_project/Utils/PasswordUtils";

export class UserEditForm extends React.Component {
  constructor(props) {
    super(props);

    let dataDefault = {
      IDUsuario: null,
      apodo: "",
      password: "",
      email: "",
      nombre: "",
      apellido: "",
      telefono: "",
      activo: 0,
      userImg: "",
      imageUuid: "",
    };

    let userDataJson = sessionStorage.getItem("userData");
    let userData = userDataJson
      ? JSON.parse(sessionStorage.getItem("userData"))
      : {};

    this.state = {
      data: Object.assign(dataDefault, userData),
      enabled: userData.activo,
      showPassword: false,
      passwordError: "",
    };
  }

  handleChange(event) {
    let data = this.state.data;

    switch (event.target.id) {
      case "app":
        this.setState({ selectedApp: event.target.value });
        this.fillPermisos(event.target.value);
        break;
      case "enabled":
        data["activo"] = this.state.enabled ? 0 : 1;
        this.setState(data);
        this.setState({ enabled: !this.state.enabled });
        break;
      default:
        data[event.target.id] = event.target.value;
        this.setState(data);
        break;
    }
  }

  async doSave(event) {
    event.preventDefault();

    if (this.state.data.password) {
      const passwordError = validatePasswordStrength(this.state.data.password);
      if (passwordError) {
        this.setState({ passwordError });
        return;
      }
    }

    let res = await this.updateUser();

    if (res) {
      sessionStorage.setItem("userData", JSON.stringify(this.state.data));
      eventBus.emit('userUpdated', this.state.data);
    }
  }

  async updateUser() {
    let result = false;

    this.props.onLoading(true);

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(this.state.data),
    };

    await doFetch("SSO", "updateUser", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  handleImageChange(result) {
    let data = this.state.data;
    data.imageUuid = result.uuid;
    this.setState({ data });
  }

  handleImageDelete() {
    let data = this.state.data;
    data.imageUuid = "";
    this.setState({ data });
  }

  render() {
    return this.state.data ? (
      <>
        <MDBContainer breakpoint="sm">
          <MDBRow>
            <MDBCol size="4">
              <MfmImageUploader
                uuid={this.state.data.imageUuid}
                img={this.state.data.userImg}
                appCode="SSO"
                mediaType="image"
                onUpload={(result) => this.handleImageChange(result)}
                onDelete={() => this.handleImageDelete()}
              />
            </MDBCol>
            <MDBCol size="8">
              <MDBRow>
                <MDBCol size="9">
                  <MDBInput
                    className="mb-4"
                    type="text"
                    id="apodo"
                    label="Nombre de usuario"
                    value={this.state.data.apodo}
                    onChange={(event) => this.handleChange(event)}
                  />
                </MDBCol>
                <MDBCol size="3">
                  <MDBSwitch
                    id="enabled"
                    label="Activo"
                    checked={this.state.enabled}
                    onChange={(event) => this.handleChange(event)}
                  />
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol size="12">
                  <MDBInput
                    className="mb-4"
                    type={this.state.showPassword ? "text" : "password"}
                    id="password"
                    label="Contraseña"
                    value={this.state.data.password}
                    onChange={(event) => {
                      this.handleChange(event);
                      this.setState({ passwordError: validatePasswordStrength(event.target.value) });
                    }}
                  />
                  {this.state.passwordError && (
                    <p className="text-danger small mt-n3 mb-2">{this.state.passwordError}</p>
                  )}
                  <MDBBtn
                    type="button"
                    color="link"
                    size="sm"
                    className="p-0 mb-3 text-decoration-none"
                    onClick={() => this.setState(prev => ({ showPassword: !prev.showPassword }))}
                  >
                    <MDBIcon fas icon={this.state.showPassword ? "eye-slash" : "eye"} className="me-1" />
                    {this.state.showPassword ? "Ocultar" : "Mostrar"}
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol size="12">
                  <MDBInput
                    className="mb-4"
                    type="text"
                    id="email"
                    label="Email"
                    value={this.state.data.email}
                    onChange={(event) => this.handleChange(event)}
                  />
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol size="12">
                  <MDBInput
                    className="mb-4"
                    type="text"
                    id="nombre"
                    label="Nombre"
                    value={this.state.data.nombre}
                    onChange={(event) => this.handleChange(event)}
                  />
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol size="12">
                  <MDBInput
                    className="mb-4"
                    type="text"
                    id="apellido"
                    label="Apellidos"
                    value={this.state.data.apellido}
                    onChange={(event) => this.handleChange(event)}
                  />
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol size="12">
                  <MDBInput
                    className="mb-4"
                    type="text"
                    id="telefono"
                    label="Teléfono"
                    value={this.state.data.telefono}
                    onChange={(event) => this.handleChange(event)}
                  />
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>

          <MDBBtn
            className="mt-4"
            onClick={(event) => this.doSave(event)}
            block
          >
            Guardar
          </MDBBtn>
        </MDBContainer>
      </>
    ) : (
      <></>
    );
  }
}
